import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import LoadingProgress from '../components/LoadingProgress'
import { Link } from 'react-router-dom'
import { User, Plus, Search } from 'lucide-react'

import { fetchUsers } from '../actions/users'

import UserList from '../components/UserList'
import UserEditForm from '../forms/UserEditForm'
import ErrorMessage from '../components/ErrorMessage'
import '../styles/UsersView.css'

class UsersView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      searchTerm: "",
      userModalOpen: false,
      editingUser: null,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleNewUser = this.handleNewUser.bind(this);
    this.handleEditUser = this.handleEditUser.bind(this);
    this.closeUserModal = this.closeUserModal.bind(this);
    this.handleUserSubmit = this.handleUserSubmit.bind(this);
  }
  componentDidMount() {
    this.props.fetchUsers()
  }

  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  handleNewUser() {
    this.setState({
      userModalOpen: true,
      editingUser: null,
    });
  }

  handleEditUser(user, e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      userModalOpen: true,
      editingUser: user,
    });
  }

  closeUserModal() {
    this.setState({
      userModalOpen: false,
      editingUser: null,
    });
  }

  handleUserSubmit() {
    this.closeUserModal();
    // Refresh the users list after successful update/create
    this.props.fetchUsers();
  }

  getFilteredUsers() {
    const { users } = this.props;
    const { searchTerm } = this.state;

    if (!users) {
      return [];
    }

    let filtered = users;

    // Filter by search term
    if (searchTerm) {
      const search = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (user) =>
          user.fullname && user.fullname.toLowerCase().includes(search),
      );
    }

    return filtered;
  }

  render() {
    const { role, type, users, loading, error } = this.props

    if (error) {
      return (
        <ErrorMessage message={error.message} />
      )
    }

    if (!users || loading) {
      return <LoadingProgress />
    }

    const filteredUsers = this.getFilteredUsers();

    return (
      <div className="users-view">
        <div className="container-fluid mt-4">
          <div className="users-header">
            <div className="header-content">
              <div className="header-text">
                <h1>
                  <i className="fas fa-users mr-3"></i>
                  Administradores
                </h1>
                <span className="subtitle-inline">
                  Gestiona los usuarios administradores del sistema
                </span>
              </div>
              <div className="search-input-wrapper">
                <i className="fas fa-search search-icon"></i>
                <input
                  type="text"
                  className="search-input"
                  placeholder="Buscar por nombre..."
                  value={this.state.searchTerm}
                  onChange={this.handleSearchChange}
                />
              </div>
              {(role === 'ADMIN') && (
                <div className="header-actions">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.handleNewUser}
                  >
                    <Plus size={16} className="mr-2" />
                    Nuevo Usuario
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="users-container">
            <div className="users-info">
              {filteredUsers.length} administradores
            </div>

            <UserList users={filteredUsers} onEditUser={this.handleEditUser} />

            {filteredUsers.length === 0 && this.state.searchTerm && (
              <div className="no-results">
                <i className="fas fa-search fa-3x mb-3"></i>
                <h3>No se encontraron usuarios</h3>
                <p>Intenta con otro término de búsqueda</p>
              </div>
            )}
          </div>
        </div>

        {this.state.userModalOpen && (
          <div className="modal-overlay" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1050
          }}>
            <div className="modal-dialog modal-lg" style={{
              margin: 0,
              maxWidth: '800px',
              width: '90%'
            }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {this.state.editingUser ? 'Editar Usuario' : 'Nuevo Usuario'}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    onClick={this.closeUserModal}
                  >
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                  <UserEditForm
                    editingUser={this.state.editingUser}
                    onSubmit={this.handleUserSubmit}
                    onCancel={this.closeUserModal}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  users: state.users.users,
  error: state.users.error,
  loading: state.users.loading,
  role: state.auth.role,
  type: state.auth.type
})

const mapDispatchToProps = dispatch => ({
  fetchUsers: bindActionCreators(fetchUsers, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(UsersView)

